// Unsubscribe.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import unsubscribeApi from '../../api/unsubscribeApi';

const Unsubscribe = () => {
  const { code } = useParams();
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cancelled, setCancelled] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyCode = async () => {
      try {
        const response = await unsubscribeApi.checkCode(code);
        if (response.data.success) {
          setEmail(response.data.email);
        } else {
          setError('Неверный или просроченный код.');
        }
      } catch (err) {
        setError('Ошибка при проверке кода.');
      } finally {
        setLoading(false);
      }
    };
    verifyCode();
  }, [code]);

  const handleUnsubscribe = async () => {
    try {
      const res = await unsubscribeApi.cancelSubscription(email, code);
      if (res.data.success) {
        setCancelled(true);
      } else {
        setError('Не удалось отменить подписку.');
      }
    } catch (err) {
      setError('Ошибка при отмене подписки.');
    }
  };

  if (loading) return <div>Загрузка...</div>;
  if (error) return <div>{error}</div>;
  if (cancelled) return <div>Ваша подписка отменена.</div>;

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Вы хотите отменить подписку для:</h2>
      <p><strong>{email}</strong></p>
      <button onClick={handleUnsubscribe}>Отменить подписку</button>
    </div>
  );
};

export default Unsubscribe;
